<template>
	<div class="transaction">
		<div class="container">
			<div class="row">
				<div class="col-12 p-md-0 mb-3">
					<div class="col-12 pt-3 pb-3 p-md-3 rounded background-white top-slider shadow d-md-flex">
						<div class="form-inline p-0 col-12 col-md-5">
							<label class="col-12 p-0 justify-content-start color-mila font-bold mb-2 font-size-sm-10">Berdasarkan Tanggal Transaksi</label>
							<div class="input-group col-12 col-md-6 p-0">
								<datepicker input-class="form-control font-size-11 font-size-sm-8 box-purple" v-model="tanggalAwal" placeholder="Dari Tanggal" bootstrap-styling >
								</datepicker>
							</div>
							<div class="input-group col-12 col-md-6 p-0">
								<datepicker input-class="form-control font-size-11 font-size-sm-8 box-purple" v-model="tanggalAkhir" placeholder="Sampai Tanggal" bootstrap-styling >
								</datepicker>
							</div>
						</div>
						<div class="form-inline p-0 col-12 col-md-7 mt-2 mt-md-0">
							<label class="col-12 p-0 justify-content-start color-mila font-bold mb-2 font-size-sm-10">Berdasarkan</label>
							<div class="input-group col-12 col-md-4 p-0 pr-md-2">
								<select class="form-control font-size-11 font-size-sm-8 box-purple" v-model="pilihan" @change="()=>{kodeinputan=''}">
									<option :value="filter.value" v-for="filter in pilihanFilter" :key="filter.value"> {{filter.name}}</option>
								</select>
							</div>
							<div class="input-group col-12 col-md-5 p-0 pr-md-2 mt-2 mt-md-0">
								<input type="text" :placeholder="placeholderFilter" class="form-control font-size-11 font-size-sm-8 box-purple" v-model="kodeinputan">
							</div>
							<div class="input-group col-12 col-md-3 p-0 pr-md-2 mt-2 mt-md-0">
								<button class="col-12 btn color-white background-button-template" type="button" @click="cari">
									<i class="fa fa-search mr-2 font-size-9 font-size-sm-8"></i><span class="font-size-12 font-size-sm-10 font-weight-normal">Cari</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 p-md-0 ">
					<div class="col-12 pl-0 pl-md-2 pr-md-2 pt-4">
						<div class="col-12 p-0 d-flex align-items-center">
							<div  class="col-12 p-0 table-responsive button-option">
								<carousel ref="carousel" id="owl-menu" class="m-auto d-flex col-12 p-0" :autoWidth="true" :responsive="{0:{items:2},600:{items:3}}" :nav="false" :loop="false" :dots="true">
									<button class="btn btn-outline-template font-size-sm-8 rounded-pill mr-3 min-width-250 min-width-sm-180 no-box-shadow" :class="{'active' : (this.status==='')}" @click="pilihStatus('')">Semua Transaksi</button>
									<button class="btn btn-outline-template font-size-sm-8 rounded-pill mr-3 min-width-250 min-width-sm-180 no-box-shadow" :class="{'active' : (this.status=='0')}" @click="pilihStatus(0)">Menunggu Pembayaran</button>
									<button class="btn btn-outline-template font-size-sm-8 rounded-pill mr-3 min-width-250 min-width-sm-180 no-box-shadow" :class="{'active' : (this.status=='3')}" @click="pilihStatus(3)">Pembayaran Diterima</button>
									<button class="btn btn-outline-template font-size-sm-8 rounded-pill mr-3 min-width-250 min-width-sm-180 no-box-shadow" :class="{'active' : (this.status=='4')}" @click="pilihStatus(4)">Sedang Diproses</button>
									<button class="btn btn-outline-template font-size-sm-8 rounded-pill mr-3 min-width-250 min-width-sm-180 no-box-shadow" :class="{'active' : (this.status=='5')}" @click="pilihStatus(5)">Dibatalkan Mobile Counter</button>
									<button class="btn btn-outline-template font-size-sm-8 rounded-pill mr-3 min-width-250 min-width-sm-180 no-box-shadow" :class="{'active' : (this.status=='6')}" @click="pilihStatus(6)">Sedang Dalam Pengiriman</button>
									<button class="btn btn-outline-template font-size-sm-8 rounded-pill mr-3 min-width-250 min-width-sm-180 no-box-shadow" :class="{'active' : (this.status=='7')}" @click="pilihStatus(7)">Sudah Diambil (Pickup)</button>
									<button class="btn btn-outline-template font-size-sm-8 rounded-pill mr-3 min-width-250 min-width-sm-180 no-box-shadow" :class="{'active' : (this.status=='9')}" @click="pilihStatus(9)">Selesai</button>
								</carousel>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 p-md-0 mb-3">
					<div class="col-12 p-0">
						<div class="col-12 pl-0 pr-0 pt-2" v-show="transactionResults.length == 0 ">
							<div class="col-12 pl-0 pr-0 pb-3 mb-4 rounded background-white cus-box-shadow font-size-sm-8">
								<vcl :width='300' :height='25'>
									<rect x="7" y="6" rx="2" ry="2" width="40" height="4" />
									<rect x="7" y="13" rx="2" ry="2" width="50" height="4" />
									<rect x="130" y="13" rx="1" ry="1" width="45" height="10" />
									<rect x="254" y="13" rx="2" ry="2" width="40" height="4" />
									<rect x="7" y="20" rx="2" ry="2" width="60" height="4" />
									<rect x="245" y="20" rx="2" ry="2" width="50" height="4" />
								</vcl>
							</div>
							<div class="col-12 pl-0 pr-0 pb-3 mb-4 mt-10 rounded background-white cus-box-shadow font-size-sm-8">
							<vcl :width='300' :height='45'>
									<rect x="7" y="6" rx="2" ry="2" width="40" height="4" />
									<rect x="258" y="6" rx="2" ry="2" width="35" height="4" />
									<rect x="30" y="18" rx="2" ry="2" width="40" height="4" />
									<rect x="130" y="18" rx="2" ry="2" width="43" height="4" />
									<rect x="248" y="18" rx="1" ry="1" width="46" height="10" />
									<rect x="35" y="25" rx="2" ry="2" width="30" height="4" />
									<rect x="140" y="25" rx="2" ry="2" width="22" height="4" />
									<rect x="42" y="33" rx="0" ry="0" width="14" height="7" />
									<rect x="144" y="33" rx="0" ry="0" width="14" height="8" />
									<rect x="248" y="32" rx="1" ry="1" width="46" height="10" />
								</vcl>
							</div>
						</div>
						<div v-if="transactionResults == 'error'" class="col-12 p-3 mt-3 rounded background-white cus-box-shadow font-size-sm-8">
							<div class="text-center">
								<div><img class="img-fluid" src="/assets/icon/no-data-found.svg" alt=""></div>
								<div class="pt-3 color-black">Belum ada transaksi tersedia.</div>
							</div>
						</div>
						<div class="col-12 pl-0 pr-0 pt-2" v-else>
							<div class="col-12 pl-0 pr-0 pt-2" v-for="(value, index) in transactionResults" v-bind:key="index" >
								<div class="col-12 pl-0 pr-0 pb-3 mb-4 rounded background-white cus-box-shadow font-size-sm-8">
									<div class="col-12 pl-3 pr-3 pt-3 d-md-flex justify-content-between" v-if="value.trx_status == 5">
										<div class="color-red font-size-sm-9 f-lato">Perhatian : Pengembalian dana akan segera diproses oleh Admin, silahkan lengkapi data bank di menu pengaturan bank.</div>
									</div>
									<div class="col-12 pl-3 pr-3 pt-3 d-md-flex justify-content-between">
										<div class="font-weight-bold color-black font-size-sm-9 f-lato">{{ value.trx_datetime | hariTanggal }}</div>
									</div>
									<div class="col-12 mt-2 pl-3 pr-3">
										<div class="col-12 col-md-12 p-0 d-md-flex">
											<div class="col-12 col-md-4 p-0 ">
												<div class="color-black">Kode Transaksi <span class="color-black font-bold f-lato">{{ value.trx_code }}</span></div>
												<div class="color-black pt-2">Mobile Counter <span class="color-mila font-weight-bold f-lato">{{ value.stockist_code }}</span></div>
											</div>
											<div class="col-12 col-md-4 pl-0 pr-2 pl-md-3 text-center d-none d-md-block">
												<a href="javascript:;" class="col-12 col-md-6">
													<router-link :to="{ name: 'transactionDetail', params: { code: value.trx_code }}" class="link-deco btn background-outline-template pt-2 pb-2"><span class="font-size-sm-9 font-size-11">Lihat Detail Transaksi</span></router-link>
												</a>
											</div>
											<div class="col-12 col-md-4 pl-0 pl-md-3 pr-0 pr-md-2 pt-2 pt-md-0 text-md-right">
												<div class="color-black">Status Transaksi</div>
												<div class="color-pink font-bold pt-2"> {{ value.trx_status | toStatus}}</div>
											</div>
										</div>
										<div class="col-12 col-md-4 p-0 mb-2 mb-md-0 mt-0 d-flex align-items-center">
											<div class="col-9 col-md-10 col-lg-9 pl-0 pr-md-0 pt-2">
												<button v-if="value.trx_status==6 || value.trx_status==7"  @click="konfirmasiPenerimaan(value.trx_id)" class="col-10 col-md-12 col-lg-10 btn background-button-template font-size-sm-9 no-box-shadow color-white">
													<span class="font-size-11 font-size-sm-9">Konfirmasi Penerimaan</span>
												</button>
												<a :href="value.download_pdf" target="_blank" class="col-10 col-md-12 col-lg-10 btn background-button-template font-size-sm-9 no-box-shadow color-white mt-2"><i class="fa fa-download mr-2"></i>Unduh Bukti</a>
											</div>
										</div>
									</div>
									<div class="col-12 pl-0 pr-0 pt-1 pt-md-2 mt-0 d-flex">
										<table class="table table-striped color-black">
											<tbody>
												<tr>
													<td widtd="57%">Total Harga Pembelian</td>
													<td class="text-right f-lato">{{ value.trx_price_total | toRupiah }}</td>
												</tr>
												<tr v-if="value.trx_shipping_metdod== 1">
													<td class="d-md-flex justify-content-md-between">
														<div class="font-weight-bold">Total Biaya Pengiriman</div>
														<div class="f-lato">{{ value.trx_weight_total | toKg }} kg x @ {{value.trx_price_shipping/(value.trx_weight_total/1000) | toRupiah}}</div>
													</td>
													<td class="text-right f-alto">{{ value.trx_price_shipping | toRupiah }}</td>
												</tr>
												<tr v-if="value.trx_price_shipping > 0 ">
													<td>Ongkos Kirim</td>
													<td class="text-right f-lato">{{ value.trx_price_shipping | toRupiah }}</td>
												</tr>
												<tr v-if="value.trx_price_unique > 0 ">
													<td>Kode Unik Transaksi</td>
													<td class="text-right f-lato">{{ value.trx_price_unique | toRupiah }}</td>
												</tr>
												<tr>
													<th class="font-size-14 font-size-sm-12">Total Pembayaran</th>
													<th class="font-size-14 font-size-sm-12 text-right f-lato">{{value.trx_price_grand_total | toRupiah}}</th>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="col-12 pl-0 pr-0 pt-2 pb-2 pb-md-0 mt-md-0 d-md-flex">
										<div class="col-12 col-md-4 p-md-0 text-md-center" v-if="value.trx_payment_method=='0'">
											<div>Metode Pembayaran</div>
											<div class="font-weight-bold">{{value.trx_payment_method | paymentMethod}}</div>
											<div class="col-4 offset-md-4 pl-0 pl-md-3"><img class="img-fluid" src="assets/icon/bonus-icon-big.svg" alt=""></div>
										</div>
										<div class="col-12 col-md-4 p-md-0 text-md-center" v-else-if="value.trx_payment_method=='1'">
											<div>Metode Pembayaran</div>
											<div class="font-weight-bold">{{value.trx_payment_method | paymentMethod}} <span class="font-weight-normal">(Verifikasi Manual)</span></div>
											<div class="col-4 offset-md-4 pl-0 pl-md-3"><img class="img-fluid" :src="'assets/bank/'+value.payment_bank.trx_payment_bank_choose_bank_account_bank.toLowerCase()+'.svg'" alt=""></div>
										</div>
										<div class="col-12 col-md-4 p-md-0 text-md-center" v-else-if="value.trx_payment_method=='2'">
											<div>Metode Pembayaran</div>
											<div class="font-weight-bold">{{value.trx_payment_method | paymentMethod}} </div>
											<div v-if="value.payment_va" class="col-4 offset-md-4 pl-0 pr-0 pl-lg-3 pr-lg-3"><img class="img-fluid" :src="'assets/bank/'+value.payment_va.trx_payment_va_bank.toLowerCase()+'.png'" alt=""></div>
										</div>
										<div class="col-12 col-md-4 p-md-0 text-md-center" v-if="value.trx_shipping_method == 1">
											<div>Metode Pengiriman</div>
											<div class="font-weight-bold">{{value.trx_shipping_method | shipping}}</div>
											<div class="col-4 offset-md-4 pl-0 pr-0 pl-lg-3 pr-lg-3"><img class="img-fluid" :src="'assets/kurir/'+value.shipping_courier.trx_shipping_courier_name.toLowerCase()+'.png'" alt=""></div>
										</div>
										<div class="col-12 col-md-4 p-md-0 text-md-center" v-else-if="value.trx_shipping_method == 0">
											<div>Metode Pengiriman</div>
											<div class="font-weight-bold">{{value.trx_shipping_method | shipping}}</div>
											<div class="col-4 offset-md-4 pt-2 pl-0 pl-md-3"><i class="fas fa-truck-pickup color-purple font-size-30"></i></div>
										</div>
										<div class="col-12 col-md-4 pl-0 pr-2 pt-4 pb-2 pb-md-0 pt-md-2 mt-3 mt-md-0" v-if="value.trx_status > 0">
											<div class="col-12 col-md-7 offset-md-5">
												<a href="javascript:;" class="d-block d-md-none">
													<router-link :to="{ name: 'transactionDetail', params: { code: value.trx_code }}" class="col-12 link-deco btn background-outline-template pt-2 pb-2"><span class="font-size-sm-9 font-size-11">Lihat Detail Transaksi</span></router-link>
												</a>
											</div>
										</div>
										<div class="col-12 col-md-4 pl-0 pr-2 pt-4 pb-2 pb-md-0 pt-md-2 mt-3 mt-md-0" v-if="value.trx_status == 0">
											<div class="col-12 col-md-10 offset-md-2 col-lg-7 offset-lg-5">
												<a href="javascript:;" class="d-block d-md-none">
													<router-link :to="{ name: 'transactionDetail', params: { code: value.trx_code }}" class="col-12 link-deco btn background-outline-template pt-2 pb-2"><span class="font-size-sm-9 font-size-11">Lihat Detail Transaksi</span></router-link>
												</a>
												<button @click="() => { batalTransaksi(value.trx_id)}" class="col-12 btn btn-outline-danger font-size-sm-9 no-box-shadow pt-2 pb-2 mt-2 mt-md-0">
													<div class="font-size-sm-9 font-size-11"><i class="fas fa-times mr-2"></i>Batal Transaksi</div>
												</button>
												<button @click="() => { bayarSekarang(value.trx_code, value.trx_buyer_mobilephone)}" class="col-12 btn background-button-template font-size-sm-9 no-box-shadow color-white pt-2 pb-2 mt-2">
													<div class="font-size-sm-9 font-size-11"><i class="fas fa-wallet mr-2"></i>Bayar Sekarang</div>
												</button>
												<button v-if="value.trx_status == 6 || value.trx_status == 7" @click="konfirmasiPenerimaan()" class="col-12 col-md-9 btn background-button-template font-size-sm-9 no-box-shadow color-white"><i class="fas fa-file-invoice-dollar mr-2"></i>Konfirmasi Penerimaan</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- pagination -->
						<div class="row" v-if="transactionPagination.total_data > 0">
							<div class="col-12 col-md-12 mt-3">
								<div class="col-12 p-0">
									<div class="row">
										<div class="col-12 col-md-12">
											<div class="row">
												<div class="col-9 offset-1 col-md-12 ml-0 ml-md-0">
													<ul class="pagination float-md-left">
														<li v-if="transactionPagination.first_page==true" @click="pagination({paramLimit:currentLimit, paramPage:transactionPagination.current==1,paramStatus:status,paramFilter:params})">
															<a class="page-link background-purple rounded-left" href="#" aria-label="Previous">
																<span aria-hidden="true"><img src="assets/icon/back_dobel.png"></span>
															</a>
														</li>
														<li v-if="transactionPagination.prev>=1" @click="pagination({paramLimit:currentLimit, paramPage:transactionPagination.prev, paramStatus:status,paramFilter:params})">
															<a class="page-link background-purple" href="#" aria-label="Previous">
																<span aria-hidden="true"><img src="assets/icon/back.png"></span>
															</a>
														</li>
														<li @click="pagination({paramLimit:currentLimit,paramPage:page, paramStatus:status,paramFilter:params})" v-for="(page,index) in transactionPagination.detail" :key="index"><span class="page-link color-purple" :class="{active:page==transactionPagination.current}" >{{ page }}</span></li>
														<li v-if="transactionPagination.next!=0" @click="pagination({paramLimit:currentLimit,paramPage:transactionPagination.next,paramStatus:status,paramFilter:params})">
															<a class="page-link background-purple" href="#">
																<span aria-hidden="true"><img src="assets/icon/back.png" style="transform: rotateY(180deg);"></span>
															</a>
														</li>
														<li v-if="transactionPagination.last_page==true" @click="pagination({paramLimit:currentLimit,paramPage:transactionPagination.total_page, paramStatus:status,paramFilter:params})">
															<a class="page-link background-purple rounded-right" href="#">
																<span aria-hidden="true"><img src="assets/icon/back_dobel.png" style="transform: rotateY(180deg);"></span>
															</a>
														</li>
													</ul>
													<ul class="pagination float-md-right" :class="[transactionPagination.total_page==1 || transactionPagination.total_page==0  ? 'mt-md-4' : '']">
														<li @click="pagination({paramLimit:currentLimit, paramPage:transactionPagination.current, paramStatus:status, paramFilter:params})">
															<a class="page-link background-purple rounded-left text-white" href="#" aria-label="Previous">
																<span aria-hidden="true" class="font-size-10"><img src="assets/icon/refresh.png" class="pr-1">Refresh</span>
															</a>
														</li>
														<li class="">
															<div class="btn-group">
																<a type="button" class="page-link background-purple dropdown-toggle background-white rounded-right text-white" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
																	<span class="font-size-10 f-lato">{{ currentLimit }}</span>
																	<div class="dropdown-menu drop-pagination">
																		<span class="dropdown-item link-black font-size-10 f-lato" v-for="(limit, index) in limit" :key="index" @click="getLimit(limit)">{{ limit }}</span>
																	</div>
																</a>
															</div>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<v-modal ref="detailPembayaran" class="modal-big">
			<template v-slot:header>
				<div class="modal-header d-block">
					<h4 slot="title" class="text-center font-size-sm-13">Detail Transaksi</h4>
				</div>
			</template>
			<div slot="body">
				<StatusTransaksi />

			</div>
		</v-modal>

		<v-modal class="konfirmasi" ref="KonfirmasiTransfer">
			<template v-slot:header>
				<div class="modal-header d-block">
					<h4 class="modal-title text-center font-size-sm-13">Konfirmasi Transfer</h4>
				</div>
			</template>
			<div slot="body">
				<KonfirmasiTransfer :paramBayar="paramBayar" />
			</div>
			<template v-slot:footer>
				<div class="modal-footer justify-content-center">
					<button type="button" class="col col-md-2 btn btn-outline-danger text-capitalize"  @click="$refs.KonfirmasiTransfer.modalHide()" ><i class="fas fa-times mr-3"></i>{{transactionDetail.data.trx_payment_method == 1 ? 'Batal' : 'Tutup'}}</button>
					<button v-if="transactionDetail.data.trx_payment_method == 1" type="button" class="col col-md-3 btn background-button-template color-white text-capitalize" @click="konfirmasiBayar();">
						Konfirmasi<i class="fas fa-arrow-right ml-3"></i>
					</button>
				</div>
			</template>
		</v-modal>

		<VModal ref="BatalTransaksi" class="modalKonfirmasi modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<div class="modal-body">
					<div class="col-12 d-md-flex mt-n3 mt-md-0">
						<div class="col-5 m-auto pt-1 pl-0 pr-md-3 pr-0">
							<img class="img-fluid" src="/assets/icon/surprise-woman.svg">
						</div>
						<div class="col-12 col-md-7 pt-3 color-black m-auto text-md-left text-center pl-0 pr-0 pl-md-3 pr-md-3">
							<div class="font-bold font-size-sm-12">Konfirmasi Batal Transaksi</div>
							<div class="font-size-sm-11 pt-2">Apakah Anda yakin ingin membatalkan transaksi ini?</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="modal-footer justify-content-center justify-content-md-end">
					<button type="button" class="col-6 col-md-3 btn btn-outline-danger text-capitalize"  @click="$refs.BatalTransaksi.modalHide()" ><i class="fas fa-times mr-3"></i>Batal</button>
					<button type="button" class="col-6 col-md-4 btn background-button-template color-white text-capitalize" @click="putBatalTransaksi();"><i class="fas fa-check mr-3"></i>Saya Yakin</button>
				</div>
			</template>
		</VModal>

		<VModal ref="konfirmasiPenerimaan" class="modalKonfirmasi modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<div class="modal-body">
					<div class="col-12 d-md-flex mt-n3 mt-md-0">
						<div class="col-5 m-auto pt-1 pl-0 pr-md-3 pr-0">
							<img class="img-fluid" src="/assets/icon/surprise-woman.svg">
						</div>
						<div class="col-12 col-md-7 pt-3 color-black m-auto text-md-left text-center pl-0 pr-0 pl-md-3 pr-md-3">
							<div class="font-bold font-size-sm-12">Konfirmasi Penerimaan</div>
							<div class="font-size-sm-11 pt-2">Apakah Anda Yakin Sudah Menerima Pesanan Ini ?</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="modal-footer justify-content-center justify-content-md-end">
					<button type="button" class="col-6 col-md-3 btn btn-outline-danger text-capitalize"  @click="$refs.konfirmasiPenerimaan.modalHide()" >
						<i class="fa fa-times mr-1"></i>
						<span>Batal</span>
					</button>
					<button type="button" class="col-6 col-md-3 btn background-button-template color-white text-capitalize" @click="putKonfirmasiPenerimaan();">
						<i class="fa fa-check mr-1"></i>
						<span>Konfirmasi</span>
					</button>
				</div>
			</template>
		</VModal>
		
		<VModal ref="konfirmasiPenerimaanSukses" class="modalKonfirmasi modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<div class="modal-body">
					<div class="col-12 d-md-flex">
						<div class="col-5 m-auto pt-1 pl-0">
							<img class="img-fluid" src="/assets/icon/smile-woman.svg">
						</div>
						<div class="col-7 color-black m-auto">
							<div class="font-size-sm-11">Terima Kasih Telah Berbelanja di Milagros</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div>
				</div>
			</template>
		</VModal>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import KonfirmasiTransfer from '@/views/member/KonfirmasiTransfer';
import StatusTransaksi from '@/views/member/StatusTransaksi';
import moment from 'moment';
import carousel from 'vue-owl-carousel';	
import VModal from '@/components/VModal';
export default {
	name: 'Transaction',
	components: {
		carousel,
		VModal,
		KonfirmasiTransfer,
		StatusTransaksi,
		Datepicker
	},

	data: () => ({
		pilihan:'trx_code',
		pilihanFilter:[{value:'trx_code' , name: 'Kode Transaksi'},{value:'stockist_code' , name:'Kode Mobile Counter'}],
		kodeinputan:'',
		currentPage:1,
		total_page:0,
		paramLimit:'',
		paramPage:'',
		paramStatus:'',
		currentLimit:10,
		status:'',
		limit:[5, 10, 20, 50, 100, 200],
		readyToLoad: true,
		detailPembayaran: false,
		KonfirmasiTransfer: false,
		msg: 'Belum ada pesanan',
		transaksi:{
			code : '',
			mobilephone : '',
		},
		dataTransaksi:{
			code:'',
			data:''
		},
		paramKonfirm:{
			trx_id:''
		},
		paramBayar: {
			bank_name: '',
			namaRekening: '',
			nomorRekening: '',
			cabang: '',
			nominal: '',
			transfer_date: '',
			note: '',
		},
		parameter: {
			trx_id : '',
			to_bank_account_id : '',
			from_bank_name : '',
			from_bank_account_name : '',
			from_bank_account_no : '',
			from_bank_branch : '',
			transfer_value : '',
			transfer_date : '',
			note : '',
		},
		paramCancel: {
			trx_id: ''
		},
		tanggalAwal:'',
		tanggalAkhir:'',
		tanggal:{
			value:'',
			comparison:'bet',
			type:'date',
			field:'trx_datetime'
		},
		tipe:{
			value:'',
			comparison:'=',
			type:'string',
			field:''
		},
		statusfilter:{
			value:'',
			comparison:'=',
			type:'string',
			field:'trx_status'
		},
		params:[],
	}),

	computed:{
		...mapState('transactionMember', ['transactionPagination', 'transactionResults', 'transactionDetail', 'konfirmResponse']),
		...mapGetters('auth', ['isAuth']),
		placeholderFilter() {
			if (this.pilihan == 'trx_code') {
				return 'Masukan Kode Transaksi'
			} else {
				return 'Masukan Kode Mobile Counter'
			}
		},

		NoteKonfirmPickup () {
			let product = this.transactionDetail.data.product
			let string = ''
			product.forEach(element => {
				string += `${element.quantity} ${element.name}, `
			});
			string = string.slice(0, -2)
			return string
		},
	},

	methods: {
		...mapActions('transactionMember', [ 'getTransaction', 'getTransactionDetail', 'konfirmation', 'cancelTransaction', 'saveConfirmResponse', 'search', 'filterStatus', 'pagination', 'Penerimaan']),
		
		cari(){
			this.currentLimit=10
			this.params = []
			if(this.tanggalAwal && this.tanggalAkhir) {
				this.tanggal.value = moment(this.tanggalAwal).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhir).format('YYYY-MM-DD')
				this.params.push(this.tanggal)
			}
			if(this.kodeinputan) {
				this.tipe.value = this.kodeinputan
				this.tipe.field = this.pilihan
				this.params.push(this.tipe)
			}
			this.search(this.params)
			this.status = ''
		},
		
		pilihStatus(value) {
			this.filterStatus({status:value, limit: this.currentLimit})
			this.status = value
			this.tanggalAwal = ''
			this.tanggalAkhir = ''
			this.kodeinputan = ''
		},
		
		getLimit(val) {
			if(this.status) {
				this.filterStatus({status:this.status, limit: val})
				this.currentLimit = val
			} else if(this.params) {
				this.pagination({paramLimit:val, paramPage:'',paramStatus:'', paramFilter:this.params})
				this.currentLimit = val
			} else{
				this.pagination({paramLimit:val, paramPage:'', paramStatus:this.status})
				this.currentLimit = val
			}
		},

		bayarSekarang(valuecode, valuephone) {
			this.transaksi.code = valuecode
			this.transaksi.mobilephone = valuephone
			this.getTransactionDetail(this.transaksi)
			this.$refs.KonfirmasiTransfer.modalShow()
		},
		
		batalTransaksi(valueid) {
			this.paramCancel.trx_id = valueid
			this.$refs.BatalTransaksi.modalShow()
		},
		
		konfirmasiBayar() {
			this.parameter.trx_id = this.transactionDetail.data.trx_id
			this.parameter.to_bank_account_id = this.transactionDetail.data.payment_bank.trx_payment_bank_choose_bank_account_id
			this.parameter.from_bank_name = this.paramBayar.bank_name
			this.parameter.from_bank_account_name = this.paramBayar.namaRekening
			this.parameter.from_bank_account_no = this.paramBayar.nomorRekening
			this.parameter.from_bank_branch = this.paramBayar.cabang
			this.parameter.transfer_value = this.paramBayar.nominal
			this.parameter.transfer_date = moment(this.paramBayar.transfer_date).format('YYYY-MM-DD')
			this.parameter.note = this.paramBayar.note
			this.konfirmation({param: this.parameter, status: false})
			if(this.parameter.trx_id && this.parameter.to_bank_account_id && this.parameter.from_bank_name && this.parameter.from_bank_account_no && this.parameter.from_bank_branch && this.parameter.transfer_value && this.parameter.transfer_date && this.parameter.note) {
				this.$refs.KonfirmasiTransfer.modalHide()
			}
		},

		putBatalTransaksi() {
			this.cancelTransaction({trx_id : this.paramCancel.trx_id})
			this.$refs.BatalTransaksi.modalHide()
		},

		putKonfirmasiPenerimaan() {
			this.Penerimaan({trx_id : this.paramKonfirm.trx_id}).then(()=> {
				this.$refs.konfirmasiPenerimaan.modalHide()
				setTimeout(() => {
					this.$refs.konfirmasiPenerimaanSukses.modalShow()
				}, 500)
					setTimeout(() => {
					this.$refs.konfirmasiPenerimaanSukses.modalHide()
				}, 2500)
			})
		},

		konfirmasiPenerimaan(trx_id) {
			this.paramKonfirm.trx_id = trx_id
			this.$refs.konfirmasiPenerimaan.modalShow()
		},
	},
	
	created() {
		this.$store.dispatch('setPageTitle', 'Transaksi');
		this.getTransaction()
	},
}
</script>

<style>
.table-striped th,  .table-striped td {
	padding-top: .5rem !important;
	padding-bottom: .5rem !important;
	padding-left: 1rem !important;
	padding-right: 1.5rem !important;
}
.box-btn-0{
	margin-top: -12px;
}
.bg-red-btn{
	background: #dc0f23;
}
#owl-menu span {
	display: block!important;
}
#owl-menu .owl-theme .owl-nav {
	margin-top: -35px;
	text-align: center;
}
.prev {
	position: absolute;
	left: -60px;
}
.next {
	position: absolute;
	right: -45px;
}
#owl-menu .owl-prev{
	float: left;
	font-family: 'fontawesome';
	margin-left: -50px;
}
#owl-menu .owl-next{
	float: right;
	margin-right: -50px;
}
#owl-menu .owl-theme .owl-menu{
	background: whitesmoke;
	display: block;
}
.vdp-datepicker input {
	background-color: #ffffff!important;
}
.vdp-datepicker {
	width: 100%;
	margin-right: 8px;	
}
.vdp-datepicker {
	padding:0px;
}
.vdp-datepicker input {
	background-color: #ffffff!important;
}
.vdp-datepicker .input-group-text {
	color: #ffffff !important;
	background-color:#9d27c0 !important;
	border: 1px solid#9d27c0 !important;
}
.pagination li .active {
	background-color: #7C1CC6 !important;
	color: #ffffff !important;
}
.dropdown-toggle .drop-pagination {
	min-width: 5rem;
	max-width: 5rem;
}
@media (max-width: 425px) {
	.vdp-datepicker {
		padding-bottom:8px;
	}
	#owl-menu .owl-stage {
		width: max-content !important;
	}
}
</style>